import React, { Component } from "react";
import "./index.less";
//let img=require("../../assets/image/nodata.png")
 import nImg from "../../assets/image/nodata.png";
interface iProps {
  tip?: string;
  iconSize?: string;
  textSize?: string;
  total?: number;
  img?:any
  tipStyle?:any
}
interface iState {}
export default class CommonEmpty extends Component<iProps, iState> {
  render() {
    let { tip, iconSize = "300px", textSize = "18px", total } = this.props;
    return (
      total === 0 && (
        <div className="component-common-empty">
          <img style={{ width: iconSize, height: iconSize }} src={this.props.img??nImg}></img>
          <div style={this.props.tipStyle? this.props.tipStyle:{fontSize: textSize }} className="tip">
            {tip || "暂无数据"}
          </div>
        </div>
      )
    );
  }
}
